/* @flow */
import React, { type Node } from 'react';
import styled from 'styled-components';

type TProps = {
	children: string,
	icon?: Node,
	iconViewBox?: string,
	iconFill?: string,
	iconStroke?: string,
	background?: string,
	color?: string,
	small?: boolean,
	withTooltip?: boolean,
	withoutBorder?: boolean,
};

const Root = styled.div`
	display: flex;
	align-items: center;
	padding: 4px 8px;
	background-color: ${({ $background }) => $background || 'transparent'};
	color: ${({ theme, $color }) => $color || theme.primaryBlackColor};
	white-space: nowrap;
	border-radius: 4px;
	${({ $small, theme }) => ($small ? theme.typography.textS : theme.typography.textMediumS)}
	border-radius: 4px;
	${({ $withoutBorder, theme }) => !$withoutBorder && `border: 1px solid ${theme.middleGrayColor};`};

	${({ $withTooltip }) => $withTooltip && `height: 100%; box-sizing: border-box;`};

	svg {
		width: 16px;
		height: 16px;
		margin-right: 6px;
		${({ $iconFill }) => $iconFill && `fill: ${$iconFill};`};
		${({ $iconStroke }) => $iconStroke && `stroke: ${$iconStroke};`};
	}
`;

const Label = ({
	children,
	icon = null,
	iconViewBox = '',
	background = '',
	color = '',
	iconFill = '',
	iconStroke = '',
	small = false,
	withTooltip = false,
	withoutBorder = false,
}: TProps) => (
	<Root
		$background={background}
		$color={color}
		$iconFill={iconFill}
		$iconStroke={iconStroke}
		$small={small}
		$withTooltip={withTooltip}
		$withoutBorder={withoutBorder}
	>
		{icon && <svg viewBox={iconViewBox || undefined}>{icon}</svg>}
		{children}
	</Root>
);

Label.defaultProps = {
	icon: null,
	iconViewBox: '',
	iconFill: '',
	iconStroke: '',
	background: '',
	color: '',
	small: false,
	withTooltip: false,
	withoutBorder: false,
};

export default Label;
